"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const capability_1 = require("../util/capability");
const types_1 = require("../types");
const __1 = require("..");
const getCopyContext = (capabilities) => {
    return {
        add: (0, capability_1.hasCapability)(capabilities, types_1.DashboardCapabilities.AddCopyContext),
        edit: (0, capability_1.hasCapability)(capabilities, types_1.DashboardCapabilities.EditCopyContext),
        onboard: (0, capability_1.hasCapability)(capabilities, types_1.DashboardCapabilities.OnboardCopyContext),
    };
};
const useCopyContext = () => {
    const { capabilities } = react_1.default.useContext(__1.AppContext);
    const [context, setContext] = react_1.default.useState(getCopyContext(capabilities));
    react_1.default.useEffect(() => {
        setContext(getCopyContext(capabilities));
    }, [capabilities]);
    return context;
};
exports.default = useCopyContext;
//# sourceMappingURL=useCopyContext.js.map